import {type CellContext} from "@tanstack/react-table";
import type React from "react";
import {memo} from "react";

import Text from "../Text";

const TableCellTextColumn: React.FC<CellContext<any, string>> = ({getValue}) => {
    return (
        <Text isTruncated variant="sm">
            {getValue()}
        </Text>
    );
};

export default memo(TableCellTextColumn);
